bam-richtext {
  display: block;

  // ----------------------------------------------- //
  // ------------------- Heading ------------------- //
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    //@include padding(0);ds update issue not found
    padding: 0;
    font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif !important;
    font-weight: var(--bal-font-weight-bold);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-bottom: 0.7rem !important;
  }
  h1 {
    font-size: 2.5rem !important;
    line-height: 3rem !important;

    @include mobile() {
      font-size: 1.75rem !important;
      line-height: 2rem !important;
    }
  }

  h2 {
    font-size: 2rem !important;
    line-height: 2.5rem !important;

    @include mobile() {
      font-size: 1.5rem !important;
      line-height: 2rem !important;
    }
  }

  h3 {
    font-size: 1.5rem !important;
    line-height: var(--bal-line-height-2) !important;

    @include mobile() {
      font-size: 1.25rem !important;
    }
  }

  h4 {
    font-size: 1.25rem !important;
    line-height: var(--bal-line-height-2) !important;

    @include mobile() {
      font-size: 1.125rem !important;
      line-height: 1.5rem !important;
    }
  }

  h5 {
    font-size: var(--bal-size-5) !important;
    line-height: var(--bal-line-height-5) !important;
  }

  // --------------------------------------------- //
  // ---------------- Text-Styles ---------------- //
  strong {
    color: inherit;
  }

  // --------------------------------------------- //
  // ---------------- Link-Styles ---------------- //
  a {
    text-decoration: underline;
    color: inherit;
  }

  // --------------------------------------------- //
  // ------------------- Lists ------------------- //
  ul,
  ol {
    li {
      a {
        margin-bottom: 0 !important;

        cursor: pointer;
      }
    }
  }

  .list li {
    color: inherit;
    &::before {
      border-color: inherit !important;
      color: inherit !important;
    }
  }

  ol {
    margin-bottom: 24px !important;
    margin-left: 24px !important;

    @include desktop() {
      margin-bottom: 32px !important;
    }

    li {
      font-family: var(--bal-font-family-text);
      margin-bottom: 12px !important;
    }
  }

  // ---------------- Link List ---------------- //
  ul.is-linklist,
  ul.is-download {
    list-style: none;
    margin-left: 0 !important;

    li {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 64px;
      padding-bottom: 2px;
      font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
      font-weight: var(--bal-font-weight-bold);

      &:after {
        content: '';
        background: #e8e8e8;
        height: 2px;
        width: 100%;
        border-radius: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }

      &:hover:after {
        background: #0014aa;
        cursor: pointer;
      }

      a {
        display: flex;
        align-items: center;
        font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
        font-weight: var(--bal-font-weight-bold);
        width: 100%;
        padding: 0.5rem 0;
        min-height: 64px;
        text-decoration: none !important;
      }
    }
  }
  
  // ------------------- List left aligned ------------------- //
  &.is-left-aligned {
    p {
      text-align: left;
    }

    ol,
    .list,
    .is-list {
      text-align: left !important;
    }

    .is-list {
      margin-left: 14px !important;
    }
  }

  // ------------------- Lists aligned ------------------- //
  &.is-lists-aligned {
    ol,
    ul:not(.is-bullet-check-circle):not(.is-list) {
      margin-left: 20px !important;
    }
    ol {
      display: inline-block;
    }
  }

  // --------------------------------------------- //
  // ------------------- Table ------------------- //
  table {
    tbody {
      tr {
        td {
          color: var(--bal-color-text-primary) !important;
        }
      }
    }
  }

  // ---------------------------------------------- //
  // -------- Invalid State Checkbox label -------- //
  &.is-invalid {
    p,
    a,
    strong {
      color: var(--bal-color-danger-4);
    }
  }

  // ---------------------------------------------- //
  // --------------- Inverted Style --------------- //
  &.is-inverted {
    * {
      color: var(--bal-color-white) !important;
    }
    a:hover {
      color: var(--bal-color-light-blue-4) !important;
    }
  }

  // ---------------------------------------------- //
  // ------- Remove margins on last-child ------- //
  :last-child {
    margin-bottom: 0 !important;
  }

  .accordion__subline {
    font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
    font-weight: var(--bal-font-weight-bold);
    font-size: 16px;
    line-height: 24px;
    color: var(--bal-color-text-normal);

    &.is-bold {
      font-weight: var(--bal-font-weight-bold);
    }
  }

  .accordion__price-wrapper {
    .accordion__price-currency {
      color: var(--bal-color-text-normal);
    }

    .accordion__price-num {
      //@include typography();ds update issue not found
      font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
      font-weight: var(--bal-font-weight-bold);
      color: var(--bal-color-text-normal);
      padding-left: 0;
      display: flex;
      text-align: right;
    }

    .accordion__price-additional-text {
      font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
      font-weight: var(--bal-font-weight-bold);
      font-size: 16px;
      line-height: 24px;
      color: var(--bal-color-text-normal);
    }
  }

  .accordion__ul-item {
    &-subline {
      padding-bottom: 4px;
    }

    &-text {
      font-family: BaloiseCreateHeadline, monospace, Arial, sans-serif;
      font-weight: var(--bal-font-weight-bold);
      font-size: 16px;
      line-height: 24px;
      color: var(--bal-color-text-normal);
    }

    &.is-forbidden {
      .accordion__ul-item-subline {
        color: var(--bal-color-text-normal);
      }
    }

    &.is-cross {
      .accordion__ul-item-subline {
        color: var(--bal-color-text-normal);
      }
    }

    &.is-excluded {
      .accordion__ul-item-subline,
      .accordion__ul-item-text {
        color: var(--bal-color-grey-5);
      }
    }
  }

  .accordion__text-block {
    display: block;
    margin: 15px 0;
  }

  .accordion__inner-seperator {
    display: block;
    border-top: 2px solid var(--bal-color-text-normal);
  }
}
